import { useTranslation } from "react-i18next";
import { Button, Space, Tooltip, Typography } from "antd";
import { EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import SearchDataIndex from "../../../context/share/SearchDataIndex";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";

const { Text } = Typography;

export function useColumnTable() {
  const getDataIndex = SearchDataIndex();
  const { t } = useTranslation("global");
  const navigate = useNavigate();

  return useMemo(
    () => [
      {
        title: t("device.tableColumn.nameDevice"),
        dataIndex: "name",
        key: "name",
        width: 240,
        ellipsis: true,
        fixed: "left",
        ...getDataIndex("name"),
        render: (text, record) => (
          <Tooltip title={text}>
            <Space direction="vertical" size={0} style={{ width: "100%" }}>
              <Text strong ellipsis>
                {text}
              </Text>
              <Text type="secondary" style={{ fontSize: 12 }} ellipsis>
                {record.marquille || "-"}
              </Text>
            </Space>
          </Tooltip>
        ),
      },
      {
        title: t("device.tableColumn.eui"),
        dataIndex: "devEui",
        key: "devEui",
        width: 180,
        ...getDataIndex("devEui"),
        render: (text) => (
          <code style={{ color: "#1677ff", fontSize: 12 }}>{text}</code>
        ),
      },
      {
        title: t("device.tableColumn.brand"),
        dataIndex: "brand",
        key: "brand",
        width: 130,
        ellipsis: true,
        ...getDataIndex("brand"),
      },
      {
        title: t("device.tableColumn.option"),
        key: "option",
        fixed: "right",
        width: 100,
        render: (_, record) => (
          <Space size="small">
            <Tooltip title={t("device.viewMetrics")}>
              <Button
                type="text"
                icon={<InfoCircleOutlined style={{ color: "#1677ff" }} />}
                onClick={() => navigate("/metrics", { state: { device: record } })}
              />
            </Tooltip>
            <Tooltip title={t("device.edit")}>
              <Button
                type="text"
                icon={<EditOutlined style={{ color: "#52c41a" }} />}
                onClick={() => navigate(`/device/${record.uuid}/edit`)}
              />
            </Tooltip>
          </Space>
        ),
      },
    ],
    [t, getDataIndex, navigate],
  );
}
